import { FC } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import CustomIcon from '@components/utils/CustomIcon';

import {
  DistanceFromCenterWrapper,
  StyledListingItemTimeZone,
  TextContainer,
  TimeZoneLocationLabel,
} from './ListingItemTimeZoneStyle';
import { ListingItemTimeZoneProps } from './ListingItemTimeZoneInterface';

const ListingItemTimezone: FC<ListingItemTimeZoneProps> = ({
  text,
  icon,
  iconColor = 'primaryBrand',
  iconSize = 16,
  className,
  textColor = 'black',
  CustomIconComponent,
  distanceFromCenter,
}) => {
  const { xl } = useBreakpoint();
  return (
    <StyledListingItemTimeZone className={className}>
      {CustomIconComponent ? <CustomIconComponent /> : null}
      {icon ? (
        <CustomIcon icon={icon} fontSize={iconSize} paletteColor={iconColor} />
      ) : null}
      <TextContainer>
        <TimeZoneLocationLabel textColor={textColor}>
          {text}
        </TimeZoneLocationLabel>
        {distanceFromCenter && distanceFromCenter > 0 ? (
          <DistanceFromCenterWrapper>
            <b>{xl ? '· Merkez: ' : 'Merkez: '}</b>
            <span>{`${distanceFromCenter} km`}</span>
          </DistanceFromCenterWrapper>
        ) : null}
      </TextContainer>
    </StyledListingItemTimeZone>
  );
};

export default ListingItemTimezone;
